"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const get_css_1 = __importDefault(require("../get-css"));
exports.propTypes = {
    opacity: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number])
};
exports.propAliases = {};
exports.propValidators = {};
const opacity = {
    className: 'opct',
    cssName: 'opacity',
    jsName: 'opacity',
    defaultUnit: ''
};
exports.propEnhancers = {
    opacity: (value) => get_css_1.default(opacity, value)
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3BhY2l0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbmhhbmNlcnMvb3BhY2l0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLDREQUFrQztBQUNsQyx5REFBK0I7QUFHbEIsUUFBQSxTQUFTLEdBQXFCO0lBQ3pDLE9BQU8sRUFBRSxvQkFBUyxDQUFDLFNBQVMsQ0FBQyxDQUFDLG9CQUFTLENBQUMsTUFBTSxFQUFFLG9CQUFTLENBQUMsTUFBTSxDQUFDLENBQUM7Q0FDbkUsQ0FBQTtBQUVZLFFBQUEsV0FBVyxHQUFnQixFQUFFLENBQUE7QUFFN0IsUUFBQSxjQUFjLEdBQW1CLEVBQUUsQ0FBQTtBQUVoRCxNQUFNLE9BQU8sR0FBRztJQUNkLFNBQVMsRUFBRSxNQUFNO0lBQ2pCLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLE1BQU0sRUFBRSxTQUFTO0lBQ2pCLFdBQVcsRUFBRSxFQUFFO0NBQ2hCLENBQUE7QUFFWSxRQUFBLGFBQWEsR0FBa0I7SUFDMUMsT0FBTyxFQUFFLENBQUMsS0FBNEIsRUFBRSxFQUFFLENBQUMsaUJBQU0sQ0FBQyxPQUFPLEVBQUUsS0FBSyxDQUFDO0NBQ2xFLENBQUEifQ==